export default "/_next/static/images/paper-tear-white-48f8415125e2023159cfa0058de2c6db.png";